import React from 'react'
import { Router } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import { ConfigProvider } from 'antd'
import { mergeDeepRight } from 'ramda'
import { ApolloProvider } from '@apollo/react-hooks'
import { ThemeProvider } from 'styled-components'
import { SWRConfig } from 'swr'
import request from '@/services/request'
import createClient from '@/graphql/client'
import defaultTheme from '@/theme'
import history from '@/utils/history'
import { AuthProvider, AuthContext } from '@/hooks/useAuth'
import { LocaleProvider, LocaleContext } from '@/hooks/useLocale'
import '@/locales/i18n'
import '../index.css'

type Props = {
  theme?: { [key: string]: any }
  // locale?: any
}

const renderer =
  ({ theme = {} }: Props = {}) =>
  (App: React.FunctionComponent) => {
    return (
      <ThemeProvider theme={mergeDeepRight(defaultTheme, theme)}>
        <RecoilRoot>
          <SWRConfig
            value={{
              revalidateOnFocus: false,
              dedupingInterval: 0,
              suspense: false,
              fetcher: request,
            }}>
            <AuthProvider>
              <AuthContext.Consumer>
                {({ logout, user }) => (
                  <ApolloProvider client={createClient({ logout, user })}>
                    <LocaleProvider>
                      <LocaleContext.Consumer>
                        {({ locale }) => (
                          <ConfigProvider locale={locale}>
                            <Router history={history}>
                              <App />
                            </Router>
                          </ConfigProvider>
                        )}
                      </LocaleContext.Consumer>
                    </LocaleProvider>
                  </ApolloProvider>
                )}
              </AuthContext.Consumer>
            </AuthProvider>
          </SWRConfig>
        </RecoilRoot>
      </ThemeProvider>
    )
  }

export default renderer
